import axios from "axios";
import React, { useEffect, useState } from "react";
import { base_url } from "../../utils/AxiosConfig";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { FaFileInvoiceDollar, FaDownload , FaPrint } from "react-icons/fa6";
import { HiArrowDownTray } from "react-icons/hi2";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import SnackbarNotification from "../../utils/SnackbarNotification";
import dayjs from "dayjs";
import { PDFViewer, pdf } from "@react-pdf/renderer";
import PaySlipDocument from "./PaySlipDocument";
import * as XLSX from "xlsx";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";

const MainPayroll = () => {
  const [payrollData, setPayrollData] = useState([]);
  const [paySlipData, setPaySlipData] = useState(null);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [Open, setOpen] = useState(false);
  const [showPayslip, setShowPayslip] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [payslipStartDate, setPayslipStartDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD"),
    // dayjs().startOf("month").format("DD-MMM-YYYY"),
  );
  const [payslipEndDate, setPayslipEndDate] = useState(
    dayjs().format("YYYY-MM-DD"),
    // dayjs().format("DD-MMM-YYYY"),
  );
  const [branchListFromAPI, setBranchListFromAPI] = useState([]);
  const [branch, setBranch] = useState("-");
  const [deptListFromAPI, setDeptListFromAPI] = useState([]);
  const [dept, setDept] = useState("-");
  const [gradeListFromAPI, setGradeListFromAPI] = useState([]);
  const [grade, setGrade] = useState("-");

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  useEffect(() => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }
    // fetchPayrollData(companyCode);
    getBranchList(companyCode);
    getDeptList(companyCode);
    getGradeList(companyCode);
  }, []);

  const getBranchList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
      // `${base_url}/api/MASTERLIST DEPARTMENT/-`
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setBranchListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getDeptList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPT/-`,
      // `${base_url}/api/MASTERLIST DEPT/-`
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      console.log("dept newArray", newArray);
      setDeptListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getGradeList = async (companyCode) => {
    const response = await axios.get(
      // `${base_url}/api/MASTERLIST GRADE/-`
      `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      // console.log('newArrayList',newArray.map((i)=>i.Description))
      // console.log('newArray',newArray)
      setGradeListFromAPI(newArray.map((i) => i.Description));
      // setGrade(newArray);
    } else {
      console.log("error");
    }
  };

  const fetchPayrollData = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCodeFromAPI = null;

    if (storedUserDataArray) {
      companyCodeFromAPI = storedUserDataArray[0].cmpcode;
    }
    try {
      const response = await axios.get(
        // `${base_url}/api/Payroll ${payslipStartDate}/${payslipEndDate}/${branch}/${dept}/${grade}`
        `${base_url}/api/Payroll/${companyCodeFromAPI}/${payslipStartDate}/${payslipEndDate}/${branch}/${dept}/${grade}`,
      );
      const data = response.data;
      console.log("data main paryoll", data);
      setPayrollData(data);
      showSnackbar("success", "payroll data generated successfully");
    } catch (err) {
      console.error(err, "error");
      showSnackbar("error", "Failed to generate payroll data.");
    }
  };

  const bondTimeportNoData = JSON.parse(
    localStorage.getItem("BondTimeportNoData") || "[]",
  );
  const headerImage = bondTimeportNoData[0]?.REP_HEADER;
  const footerImage = bondTimeportNoData[0]?.REP_FOOTER;

  const navigate = useNavigate();

  const printPayrollData = () => {
    // console.log("Print is clicked");
    navigate("/admin/payrollListPrint", {
      state: {
        payrollData,
      },
    });
  };

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const callPaySlipAPI = async (empID, empRow) => {
    setIsLoading(true);
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    try {
      const response = await axios.get(
        `${base_url}/api/Payslip/${companyCode}/${payslipStartDate}/${payslipEndDate}/${empID}`,
      );

      if (response.status === 200) {
        const data = Array.isArray(response.data) ? response.data[0] : response.data;
        setPaySlipData(data || empRow);
        setSelectedEmp(empRow);
        setShowPayslip(true);
      } else {
        showSnackbar("error", "Failed to generate payslip.");
      }
    } catch (error) {
      showSnackbar("error", "An error occurred while payslip.");
    } finally {
      setIsLoading(false);
    }
  };

  const resetPayrollFilters = () => {
    setBranch("-");
    setDept("-");
    setGrade("-");
  };

  const formatCurrency = (amt) =>
    Number(amt || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });

  const downloadExcel = () => {
    if (!payrollData?.length) return;
    const wsData = payrollData.map((d, i) => ({
      "Sl No": i + 1,
      "Emp ID": d.EMP_ID,
      Name: d.NAME,
      "Job Title": d.JOB_TITLE,
      Department: d.DEPARTMENT,
      Division: d.BRANCH,
      Status: d.STATUS,
      Nationality: d.NATIONALITY,
      "Join Date": dayjs(d.JOIN_DATE).format("DD-MMM-YYYY"),
      "Basic Pay": d.BASIC_PAY,
      Allowances: d.ALLOWANCES,
      Increments: d.INCREMENTS,
      "Nr Hrs": d.NR_HRS,
      "Ot Hrs": d.OT_HRS,
      "Ots Hrs": d.OTS_HRS,
      "Abs Days": d.ABS_DAYS,
      "Total Wage": formatCurrency(d.TOTAL_WAGE),
      ...(Open && {
        "Oth Additions": d.OTH_ADDITIONS,
        "Gross Pay": formatCurrency(d.GROSS_PAY),
        Deductions: formatCurrency(d.DEDUCTIONS),
        "Net Pay": formatCurrency(d.NET_PAY),
        "Loans & Adv": formatCurrency(d.LOANS_AND_ADV),
      }),
    }));
    const ws = XLSX.utils.json_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Payroll");
    XLSX.writeFile(
      wb,
      `Payroll_${payslipStartDate}_to_${payslipEndDate}.xlsx`,
    );
    showSnackbar("success", "Excel downloaded successfully");
  };

  const handleExport = () => {
    if (!payrollData?.length) return;
    const csvRows = [];
    const headers = [
      "Sl No",
      "Emp ID",
      "Name",
      "Job Title",
      "Department",
      "Division",
      "Status",
      "Nationality",
      "Join Date",
      "Basic Pay",
      "Allowances",
      "Increments",
      "Nr Hrs",
      "Ot Hrs",
      "Ots Hrs",
      "Abs Days",
      "Total Wage",
    ];
    if (Open) {
      headers.push(
        "Oth Additions",
        "Gross Pay",
        "Deductions",
        "Net Pay",
        "Loans & Adv",
      );
    }
    csvRows.push(headers.join(","));
    payrollData.forEach((d, i) => {
      const row = [
        i + 1,
        d.EMP_ID,
        `"${d.NAME || ""}"`,
        `"${d.JOB_TITLE || ""}"`,
        `"${d.DEPARTMENT || ""}"`,
        `"${d.BRANCH || ""}"`,
        d.STATUS,
        `"${d.NATIONALITY || ""}"`,
        dayjs(d.JOIN_DATE).format("DD-MMM-YYYY"),
        d.BASIC_PAY,
        d.ALLOWANCES,
        d.INCREMENTS,
        d.NR_HRS,
        d.OT_HRS,
        d.OTS_HRS,
        d.ABS_DAYS,
        formatCurrency(d.TOTAL_WAGE),
      ];
      if (Open) {
        row.push(
          d.OTH_ADDITIONS,
          formatCurrency(d.GROSS_PAY),
          formatCurrency(d.DEDUCTIONS),
          formatCurrency(d.NET_PAY),
          formatCurrency(d.LOANS_AND_ADV),
        );
      }
      csvRows.push(row.join(","));
    });
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Payroll_${payslipStartDate}_to_${payslipEndDate}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    showSnackbar("success", "CSV exported successfully");
  };

  return (
    <div>
      <div className="flex justify-between items-end mb-4 ">
        {/* <h6 className="text-2xl mb-2 font-bold text-gray-600 flex  justify-start items-center">
          Payroll
        </h6> */}

        <div className="flex justify-left items-center">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
          <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
            {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              PAYROLL
            </span>
          </h6>
        </div>

        <div className="flex justify-center items-end gap-4 ">
          {/* Branch Select */}
          <FormControl variant="outlined" sx={{ minWidth: 180 }} size="small">
            <InputLabel id="branch-select-label">Branch</InputLabel>
            <Select
              labelId="branch-select-label"
              value={branch}
              // onChange={(e) => handleChange(e, "division")}
              label="Branch"
            >
              <MenuItem value="-">
                <em>None</em>
              </MenuItem>
              {branchListFromAPI?.map((b) => (
                <MenuItem
                  key={b.DEPTNO}
                  value={b}
                  onClick={() => {
                    //   setSelectedDivision(b.deptnodesc);
                    setBranch(b);
                  }}
                >
                  {b}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="outlined" sx={{ minWidth: 180 }} size="small">
            <InputLabel id="department-select-label">Department</InputLabel>
            <Select
              labelId="department-select-label"
              value={dept}
              // onChange={(e) => handleChange(e, "department")}
              label="Department"
            >
              <MenuItem value="-">
                <em>None</em>
              </MenuItem>
              {deptListFromAPI?.map((dept) => (
                <MenuItem
                  // key={dept.id}
                  value={dept}
                  onClick={() => {
                    setDept(dept);
                    //   setSelectedDepartmentCode(dept.code);
                  }}
                >
                  {dept}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="outlined" sx={{ minWidth: 180 }} size="small">
            <InputLabel id="grade-select-label">Grade</InputLabel>
            <Select
              labelId="grade-select-label"
              value={grade}
              // onChange={(e) => handleChange(e, "grade")}
              label="Grade"
            >
              <MenuItem value="-">
                <em>None</em>
              </MenuItem>
              {gradeListFromAPI?.map((g) => (
                <MenuItem
                  // key={g.TranId}
                  value={g}
                  onClick={() => {
                    setGrade(g);
                  }}
                >
                  {g}
                </MenuItem>
              ))}
            </Select>
          </FormControl>


          <button
            // onClick={() => callGeneratePayrollAPI()}
            onClick={() => resetPayrollFilters()}
            className="btn btn-sm"
            style={{ backgroundColor: "#1DC7AD", color: "#ffffff" }}
          >
            Reset Filters
          </button>

          <div className="d-flex">
            <div>
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary"
              >
                Start Date
              </label>
              <input
                type="date"
                className="form-control"
                id="startDate"
                name="startDate"
                value={payslipStartDate}
                onChange={(e) => setPayslipStartDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>

            <div className="ms-2">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary"
              >
                End Date
              </label>
              <input
                type="date"
                className="form-control"
                id="endDate"
                name="endDate"
                value={payslipEndDate}
                onChange={(e) => setPayslipEndDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>



          <button
            // onClick={() => callGeneratePayrollAPI()}
            onClick={() => fetchPayrollData()}
            className="btn btn-sm"
            style={{ backgroundColor: "#1DAAF7", color: "#ffffff" }}
          >
            Generate Payroll
          </button>

          

          <div className="mb-2">
            {Open === true ? (
              <>
                <LuPanelRightOpen onClick={() => setOpen(false)} />
              </>
            ) : null}
            {Open === false ? (
              <>
                <LuPanelLeftOpen onClick={() => setOpen(true)} />
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div className="overflow-auto max-w-85 scrollbar-none rounded-md">
        {payrollData?.length > 0 && (
          <div className="flex justify-end items-center gap-2 mb-2">
            
            
            <button
              className="px-2 flex items-center gap-2 cursor-pointer bg-orange-500 px-2 py-2 rounded text-white text-xs"
              onClick={() => printPayrollData()}
              >
              <FaPrint className="text-sm" />
              Print Payroll
            </button>
            <button
              className="flex items-center gap-2 cursor-pointer bg-blue-500 px-2 py-2 rounded text-white text-xs"
              style={{ width: "140px" }}
              onClick={downloadExcel}
            >
              <HiArrowDownTray className="text-sm" />
              Download Excel
            </button>
            <button
              disabled={!payrollData?.length}
              onClick={handleExport}
              className={`flex items-center gap-2 px-3 py-2 text-xs rounded-md text-white transition-all duration-200 shadow-sm ${
                !payrollData?.length
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-emerald-600 hover:bg-emerald-700"
              }`}
            >
              <HiArrowDownTray className="text-sm" />
              Export CSV
            </button>
          </div>
        )}
        {payrollData ? (
          <>
            {/* <table className="table-auto w-full bg-white text-xs border-collapse border border-gray-300 shadow-sm rounded-md px-6 overflox-x-auto"> */}
            <table className="shadow-sm min-w-full  rounded-sm border border-[gray-300] text-xs ">
              <thead>
                <tr className="bg-[#2663EB] text-white">
                  <th className="px-1.5 py-1  font-normal">Sl No</th>
                  <th className="px-1.5 py-1   font-normal">Emp ID</th>
                  <th className="px-1.5 py-1   font-normal">Name</th>
                  <th className="px-1.5 py-1   font-normal">Job Title</th>
                  <th className="px-1.5 py-1   font-normal">Department</th>
                  <th className="px-1.5 py-1   font-normal">Division</th>
                  <th className="px-1.5 py-1   font-normal">Status</th>
                  <th className="px-1.5 py-1   font-normal">Nationality</th>
                  <th className="px-1.5 py-1   font-normal">Join Date</th>
                  <th className="px-1.5 py-1   font-normal">Basic Pay</th>
                  <th className="px-1.5 py-1   font-normal">Allowances</th>
                  <th className="px-1.5 py-1   font-normal">Increments</th>
                  <th className="px-1.5 py-1   font-normal">Nr Hrs</th>
                  <th className="px-1.5 py-1   font-normal">Ot Hrs</th>
                  <th className="px-1.5 py-1   font-normal">Ots Hrs</th>
                  <th className="px-1.5 py-1   font-normal">Abs Days</th>
                  <th className="px-1.5 py-1   font-normal">Total Wage</th>

                  {Open && (
                    <>
                      <th className="px-1.5 py-1   font-normal">
                        Oth Additions
                      </th>
                      <th className="px-1.5 py-1   font-normal">Gross Pay</th>
                      <th className="px-1.5 py-1   font-normal">Deductions</th>
                      <th className="px-1.5 py-1   font-normal">Net Pay</th>
                      <th className="px-1.5 py-1   font-normal">Loans & Adv</th>
                    </>
                  )}

                  <th className="px-1.5 py-1   font-normal text-center">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {payrollData?.map((d, i) => (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-1.5 py-1 border">{i + 1}</td>
                    <td className="px-1.5 py-1 border">{d.EMP_ID}</td>
                    <td className="px-1.5 py-1 border">{d.NAME}</td>
                    <td className="px-1.5 py-1 border">{d.JOB_TITLE}</td>
                    <td className="px-1.5 py-1 border">{d.DEPARTMENT}</td>
                    <td className="px-1.5 py-1 border">{d.BRANCH}</td>
                    <td className="px-1.5 py-1 border">{d.STATUS}</td>
                    <td className="px-1.5 py-1 border">{d.NATIONALITY}</td>
                    <td className="px-1.5 py-1 border">
                      {/* {d.JOIN_DATE
                        ? new Date(d.JOIN_DATE).toLocaleDateString("en-GB")
                        : ""} */}
                      {dayjs(d.JOIN_DATE).format("DD-MMM-YYYY ")}
                    </td>
                    <td className="px-1.5 py-1 border">{d.BASIC_PAY}</td>
                    <td className="px-1.5 py-1 border">{d.ALLOWANCES}</td>
                    <td className="px-1.5 py-1 border">{d.INCREMENTS}</td>
                    <td className="px-1.5 py-1 border">{d.NR_HRS}</td>
                    <td className="px-1.5 py-1 border">{d.OT_HRS}</td>
                    <td className="px-1.5 py-1 border">{d.OTS_HRS}</td>
                    <td className="px-1.5 py-1 border">{d.ABS_DAYS}</td>
                    <td className="px-1.5 py-1 border">{d.TOTAL_WAGE}</td>

                    {Open && (
                      <>
                        <td className="px-1.5 py-1 border">
                          {d.OTH_ADDITIONS}
                        </td>
                        <td className="px-1.5 py-1 border">{d.GROSS_PAY}</td>
                        <td className="px-1.5 py-1 border">{d.DEDUCTIONS}</td>
                        <td className="px-1.5 py-1 border">{d.NET_PAY}</td>
                        <td className="px-1.5 py-1 border">
                          {d.LOANS_AND_ADV}
                        </td>
                      </>
                    )}

                    <td className="px-1.5 py-1 border text-center space-x-2">
                      <button
                        className="bg-purple-500 text-white px-1 py-1 rounded-md text-xs hover:bg-purple-700 flex items-center gap-1 disabled:bg-purple-300"
                        onClick={() => callPaySlipAPI(d.EMP_ID, d)}
                        disabled={isLoading}
                      >
                        <FaFileInvoiceDollar className="text-sm" />
                        {isLoading ? "Loading..." : "Payslip"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : null}
        <SnackbarNotification
          open={snackbar.open}
          severity={snackbar.severity}
          message={snackbar.message}
          onClose={handleClose}
        />
      </div>
      {showPayslip && paySlipData && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-xl w-[90vw] h-[90vh] flex flex-col relative">
            <div className="flex items-center justify-between px-6 py-3 border-b border-gray-200">
              <h2 className="text-lg font-bold text-gray-800">
                Payslip - {paySlipData.NAME || selectedEmp?.NAME} ({paySlipData.EMP_ID || selectedEmp?.EMP_ID})
              </h2>
              <div className="flex items-center gap-3">
                <button
                  onClick={async () => {
                    const blob = await pdf(
                      <PaySlipDocument
                        data={paySlipData}
                        startDate={payslipStartDate}
                        endDate={payslipEndDate}
                        headerImage={headerImage}
                        footerImage={footerImage}
                      />
                    ).toBlob();
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `Payslip_${paySlipData.EMP_ID || selectedEmp?.EMP_ID}_${payslipStartDate}.pdf`;
                    a.click();
                    URL.revokeObjectURL(url);
                  }}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg transition-colors"
                >
                  <FaDownload />
                  Download
                </button>
                <button
                  onClick={() => {
                    setShowPayslip(false);
                    setPaySlipData(null);
                    setSelectedEmp(null);
                  }}
                  className="px-3 py-1.5 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm font-medium rounded-lg transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
            <div className="flex-1">
              <PDFViewer style={{ width: "100%", height: "100%" }}>
                <PaySlipDocument
                  data={paySlipData}
                  startDate={payslipStartDate}
                  endDate={payslipEndDate}
                  headerImage={headerImage}
                  footerImage={footerImage}
                />
              </PDFViewer>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainPayroll;
